import style from './preview-section.module.scss';
import template from '@components/careers/vacancies/vacancies.module.scss';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import React from 'react';
import Image from 'next/image';
import { ButtonHandshkaeGreen } from '@components/shared/buttons/button-handshake-green';

interface IPreviewSectionProps {
  title: string;
  subtitle: string;
  link: string;
  wraps: any[];
}

const PreviewSection = ({ title, subtitle, link, wraps }: IPreviewSectionProps) => {
  function scrollToBlock(blockId: string) {
    const block = document.getElementById(blockId) as HTMLElement;
    //This is height of header
    const yOffset = -80;
    const y = block.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  return (
    <section className={`${template.section} ${template.section_light}`}>
      {/* <div className={`${template.container} ${template.container_large}`}>
                <Breadcrumbs />
            </div> */}
      <div className={`${template.container} ${template.container_small} ${template.mb16}`}>
        <div className={`${template.title} ${template.title_large} ${template.text_align_c} ${template.mb20}`}>
          {title}
        </div>
        <div className={`${template.text} ${template.text_color_main} ${template.text_small} ${template.text_align_c}`}>
          {subtitle}
        </div>
      </div>
      <div className={template.button_wrapper}>
        <ButtonHandshkaeGreen text="See open roles" action={() => scrollToBlock('currentJobs')} />
      </div>
      <div className={`${template.container} ${template.container_large}`}>
        <div className={`${style.flex}`}>
          {wraps.map((item: any, index: number) => {
            switch (item.type) {
              case 'imageblock':
                return (
                  <div key={index} className={`${style.item}`}>
                    <div className={`${style.item__image}`}>
                      <Image src={item.imageSrc} alt={item.imageAlt} layout={'fill'} />
                    </div>
                  </div>
                );
              case 'textblock':
                return (
                  <div key={index} className={`${style.item}`}>
                    <div className={`${style.item__block}`}>
                      <div className={`${style.item__block__title}`}>{item.title}</div>
                      <div className={`${style.item__specialist}`}>
                        <div className={`${style.item__specialist__icon}`}>
                          <Image src={item.specialistIcon} alt={item.specialist} width="40" height="40" />
                        </div>
                        <div className={`${style.item__specialist__position}`}>{item.specialist}</div>
                      </div>
                    </div>
                  </div>
                );
            }
          })}
        </div>
      </div>
    </section>
  );
};

export default PreviewSection;
